import { Button } from '@cian/ui-kit/button';
import { Header2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingConsultBannerProps {
  phone?: string | null;
  onChatClick(): void;
}

export function NewbuildingConsultTopBanner({ phone, onChatClick }: INewbuildingConsultBannerProps) {
  const headerText = `Проконсультируйтесь про новостройки${phone ? '' : ' в чате'}!`;

  return (
    <div className={styles['container']}>
      <div>
        <Header2 color="black_100">{headerText}</Header2>
        {phone && <div className={styles['text']}>{`Звоните по номеру ${phone} или пишите в чат`}</div>}
      </div>
      <Button size="XS" theme="fill_primary" onClick={onChatClick}>
        Написать в чат
      </Button>
    </div>
  );
}
